import PropTypes from 'prop-types';
import queryString from 'querystring';
import React, { useContext, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import ButtonLink from '../../components/elements/ButtonLink';
import Card from '../../components/elements/Card';
import DataTable from '../../components/elements/DataTable';
import ErrorHandler from '../../components/elements/ErrorHandler';
import Text from '../../components/fields/Text';
import AturHargaFilter from '../../components/fragments/AturHargaFilter/AturHargaFilter';
import IconAturHET from '../../components/icons/IconAturHET';
import { AppContext } from '../../contexts';
import { thousand } from '../../utils/format';
import { useDebounce } from '../../utils/hooks';
import { getRegional } from '../../utils/storage';
import { fetchProductPriceLists } from './actions';
import styles from './styles.scoped.css';

export default function TabelHarga({ category }) {
  const dispatch = useDispatch();
  const location = useLocation();
  const { setBreadcrumbs } = useContext(AppContext);
  const [search, setSearch] = useState('');

  const userRegion = getRegional();
  const { dataDetailUser } = useSelector((state) => state.pageBase);
  const {
    page = 1,
    size = 10,
    regional = dataDetailUser.regionalId === 'All'
      ? ''
      : dataDetailUser.regionalId,
    // regional_name,
    provinceId = dataDetailUser.provinceId === 'All'
      ? ''
      : dataDetailUser.provinceId,
    cityId = '',
  } = queryString.parse(location.search.replace('?', ''));

  const {
    dataProductPriceLists: { data, meta },
    isLoadingProductPriceLists,
    messageProductPriceLists,
  } = useSelector((s) => s.prices);

  const debounceParams = useDebounce(
    page + size + category + regional + provinceId + cityId + search,
    500
  );

  function getAllParams(page) {
    let allParams = {
      regional,
      page: page,
      provinceId,
      cityId,
      search,
      categoryId: category.categoryId,
    };
    if (!userRegion) {
      allParams.regional = regional;
    }
    return allParams;
  }

  const allParams = {
    page,
    size,
    search,
    provinceId: provinceId === 'All' ? '' : provinceId,
    cityId: cityId === 'All' ? '' : cityId,
    regional: regional === 'All' ? '' : regional,
  };

  useEffect(() => {
    setBreadcrumbs(['Atur HET LPG 3 Kg']);
  }, []);

  useEffect(() => {
    if (category?.categoryId) {
      dispatch(
        fetchProductPriceLists({
          ...allParams,
          categoryId: category.categoryId,
        })
      );
    }
  }, [category, debounceParams]);

  const fetchProductList = (page) => {
    dispatch(fetchProductPriceLists(getAllParams(page + 1)));
  };

  const renderAction = (region, provinceId, cityId, maxPrice, minPrice) => {
    const query = queryString.stringify({
      region,
      provinceId,
      cityId,
      maxPrice,
      minPrice,
    });
    return (
      <ButtonLink
        className={styles['btn-detail']}
        outlined
        to={location.pathname + '/set?' + query}
      >
        <span>Ubah Harga</span>
      </ButtonLink>
    );
  };

  const goToUpload = (region, provinceId, cityId) => {
    const query = queryString.stringify({
      region,
      provinceId,
      cityId,
    });
    return location.pathname + '/' + 'setting-sekaligus?' + query;
  };

  const column = [
    { heading: 'Regional', value: 'region' },
    { heading: 'Provinsi', value: 'provinceName' },
    { heading: 'Kabupaten/Kota', value: 'cityName' },
    {
      heading: 'Range HET LPG 3 Kg',
      value: ({ prices }) =>
        `Rp${thousand(prices['7d80fe3d-d361-4193-ad67-730aa1ced4a6']?.productMinPrice)} - Rp${thousand(
          prices['7d80fe3d-d361-4193-ad67-730aa1ced4a6']?.productMaxPrice
        )}`,
    },
    {
      heading: 'Ubah Harga',
      value: ({ regionId, provinceId, cityId, prices }) =>
        renderAction(
          regionId,
          provinceId,
          cityId,
          prices['7d80fe3d-d361-4193-ad67-730aa1ced4a6']?.productMaxPrice,
          prices['7d80fe3d-d361-4193-ad67-730aa1ced4a6']?.productMinPrice
        ),
    },
  ];

  if (messageProductPriceLists) {
    return <ErrorHandler message={messageProductPriceLists} />;
  }

  return (
    <>
      <AturHargaFilter />
      <Card className={styles.searchContainer}>
        <div className={styles.uploadContainer}>
          <ButtonLink
            className={styles.updatePriceBtn}
            to={'/price/set'}
            type="primary"
          >
            <IconAturHET color={'white'} /> Ubah Semua Harga
          </ButtonLink>
          <ButtonLink
            className={styles.updatePriceBtn}
            style={'red'}
            to={goToUpload(regional, provinceId, cityId)}
            type={'primary'}
          >
            <img src="assets/ic-upload.svg" />
            Ubah Harga Dengan File
          </ButtonLink>
        </div>
        <div className={styles['filter-wrap']}>
          <div className={styles.filters}>
            <Text
              className={styles['search-bar']}
              hideLabel
              inputProps={{
                placeholder: 'Cari data...',
                value: search,
                icon: 'ic-search.svg',
                onChange: (e) => setSearch(e.target.value),
              }}
            />
          </div>
        </div>
      </Card>
      <Card className={styles.table}>
        <div className={styles['table-container']}>
          <DataTable
            className={styles.table}
            column={column}
            data={data}
            endTreshould={200}
            loading={isLoadingProductPriceLists}
            meta={meta}
            onEndReached={() => fetchProductList(meta.page)}
            onRefresh={fetchProductList}
            size={size}
            withIndex
          />
        </div>
      </Card>
    </>
  );
}

TabelHarga.propTypes = {
  category: PropTypes.shape({
    categoryId: PropTypes.string,
    unit_name: PropTypes.string,
    unit_symbol: PropTypes.string,
  }),
};
